const t=(t,r={})=>{const{withQueryString:e}=r;if(t)try{if(/^(http|https)/.test(t)){const{pathname:r,search:n}=new URL(t);return`${r}${e?n:""}`}return t.startsWith("/")?t:`/${t}`}catch(r){return t}};export{t as default};
